import { Component, OnInit } from '@angular/core';
import { QuizItem } from '../interfaces/quiz.interface';
import { QuizService } from '../services/quiz.service';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { AuthService } from 'src/app/auth/auth.service';

import { PermissionHelper } from 'src/app/shared/helpers/permission.helper';

@Component({
  selector: 'app-quiz-list',
  templateUrl: './quiz-list.component.html',
  styleUrls: ['./quiz-list.component.css'],
})
export class QuizListComponent implements OnInit {
  devocional: QuizItem[] = [];
  showLoader = false;
  permissionsAllowed: string[] = [];

  constructor(
    private quizService: QuizService,
    private loaderService: LoaderService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Obter rotas/permissões permitidas salvas pelo backend
    this.permissionsAllowed = JSON.parse(sessionStorage.getItem('routes')) || [];
    this.getdevocional();
  }

  hasPermission(permission: string): boolean {
    return PermissionHelper.getRole(permission);
  }

  getdevocional(): void {
    this.showLoader = true;
    this.quizService
      .getdevocional()
      .then((res) => {
        // Assume-se que a API retorna em res.data ou num array direto
        this.devocional = res.data || res;
        this.showLoader = false;
      })
      .catch((err) => {
        this.snackBar.open('Erro ao carregar devocional.', null, { duration: 3000 });
        this.showLoader = false;
      });
  }

  delete(id: string | number, title: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir Quiz',
        text: `Deseja remover o quiz "${title}"?`,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loaderService.showLoader();
        this.quizService
          .deleteQuiz(id)
          .then((res: any) => {
            this.snackBar.open(res.message || 'Quiz removido com sucesso!', null, { duration: 4000 });
            this.getdevocional();
            this.loaderService.closeLoader();
          })
          .catch((err: any) => {
            this.snackBar.open(err.error?.message || 'Algo de errado aconteceu', null, { duration: 3000 });
            this.loaderService.closeLoader();
          });
      }
    });
  }

  isExpired(endDate: string | Date): boolean {
    return new Date(endDate) < new Date();
  }
}
